import { ScreenDevicePage } from '@hq/screen-scan';
import { useNavigate } from 'react-router-dom';
import { hq } from '../session';

/**
 * 大屏设备（OPS 门户）：运营范围内的大屏总表，可逐台吊销。
 * 确认动作不在后台做——必须到屏前看屏上的 12 位申请码，再到「申请码确认」页填入。
 */
export default function ScreenDevices() {
  const navigate = useNavigate();

  return (
    <ScreenDevicePage
      hq={hq}
      title="大屏设备"
      canDisable
      showPending
      onScan={() => navigate('/system/screen-scan')}
      onOpenScreen={() => window.open('/screen', '_blank')}
    />
  );
}
